import { Injectable } from '@angular/core';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ITProyecto } from '../models/IProyectos.model'
//import { ITBancos } from '../models/ITBancos.model'

@Injectable({
    providedIn: 'root'
})

export class RBusquedaService {

    constructor(private apiService: ApiService) { }

    insertar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.treference);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.treference);
        return this.apiService.executePutJson(data).pipe();
    }


    eliminar(tipinv:any , clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.treference);
        return this.apiService.executeDeleteJson(`${tipinv}/${clase}`)
    }

    obtener(tipinv:any , clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.treference);
        return this.apiService.execGetQueryJson(`${tipinv}/${clase}`)
    }

    buscar(tipinv: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.treference+'buscar');
        return this.apiService.execGetQueryJson(`?tipinv=${tipinv}`)
    }

}
